import './styles.css';
import logo from '../../logo.png';
import { useHistory } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { useAppSelector } from '../../core/hooks';
import { useAppDispatch } from './../../core/hooks';
import { setName } from '../../core/slices/userSlice';

function Landing() {

    const history = useHistory();

    const userName = useAppSelector(state => state.user.name);
    const dispatch = useAppDispatch();

    function onUserNameChange(event: React.ChangeEvent<HTMLInputElement>) {
        dispatch(setName(event.target.value))
    }

    function validateNameAndProceed() {
        if (userName.length) {
            history.push('/dashboard');
        } else {
            window.alert('Please enter your name to proceed.')
        }
    }

    return (
        <div className="landing">
            <header>
                <div className="logo">
                    <img className="fluid-img" src={logo} alt="App Logo" />
                </div>
            </header>
            <div className="hero">
                <div className="hero-image-wrapper">
                    <img className="fluid-img" src="images/landing-bg.jpg" alt="Landing Hero" />
                    <div className="hero-img-gradient"></div>
                </div>
                <div className="hero-content-wrapper">
                    <span className="welcome-text">Welcome, Guest!</span>
                    <h1 className="hero-title">Unlimited movies, TV shows, and more.</h1>
                    <div className="hero__form">
                        <input placeholder="Please identify yourself" value={userName} onChange={onUserNameChange} />
                        <button onClick={validateNameAndProceed}>Continue <FontAwesomeIcon icon={faAngleRight} size="1x" /> </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Landing;